export const defaultValue = {
  id: '1019',
  name: 'Satellit',
  generatorId: 'e4955676-02c9-45a2-8709-aede02384d93',
  generatorUrl: '',
  thumbnail: '',
  modifiedAt: '2025-01-21T14:25:47.296Z',
  materials: {
    '0': {
      id: 'mat_0',
      name: 'Material 0',
      tint: '#6B6B6Bff',
      metalness: 0,
      roughness: 0.45,
      specular: 0.5,
      emission: 0,
    },
    '1': {
      id: 'mat_1',
      name: 'Material 1',
      tint: '#CFCFCFff',
      metalness: 1,
      roughness: 0.45,
      specular: 0.5,
      emission: 0,
    },
    '2': {
      id: 'mat_2',
      name: 'Material 2',
      tint: '#FF9C57ff',
      metalness: 1,
      roughness: 0.45,
      specular: 0.5,
      emission: 0,
    },
    '3': {
      id: 'mat_3',
      name: 'Material 3',
      tint: '#FF3751ff',
      metalness: 1,
      roughness: 0.45,
      specular: 0.5,
      emission: 0,
    },
  },
  valuesModel: {
    LOD: 0.5,
    MainHeight: 0.5,
    BodyHeight: 0.5,
    BodyThickness: 0.25,
    TailSectionsAmount: 0.4,
    Tail: 1,
    FrontAntenna: 1,
    RearAntenna: 1,
    DishFrontAntennaLength: 0.5,
    AntennaThickness: 0.5,
    RearAntennaLength: 0.8,
    SolarPanelDetail: 1,
    Array: 0,
    SolarPanelThickness: 0.5,
    SolarPanelLength: 0.5,
    SolarPanelWidth: 0.5,
    SolarPanelsOrbit: 0.5,
    SolarPanelTilt: 0.5,
    SolarPanelAmount: 0.5,
    SolarPanelVerticalPosition: 0.5,
    DishRadius: 0.5,
    DishTilt: 0,
    DishRotation: 0.5,
    DishMountRadius: 0.5,
    DishDetail: 0.5,
    DishLayersAmount: 0.5,
    DishSelector: 0.1666667,
  },
  modifiers: {
    modifiersWack_OffsetX: 0.5,
    modifiersWack_OffsetZ: 0.5,
    modifiersWack_RotateX: 0.5,
    modifiersWack_RotateY: 0.5,
    modifiersWack_RotateZ: 0.5,
    modifiersWack_TaperTopX: 0.5,
    modifiersWack_TaperTopY: 0.5,
  },
};
